(() => {
  let timer;
  function update(root = document) {
    const today = new Date();
    const orderDay = Object.fromEntries(new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(today).map(part => [part.type, part.value]));
    const completion = new Date(Date.UTC(Number(orderDay.year), Number(orderDay.month) - 1, Number(orderDay.day) + 28, 12));
    // Following Tuesday is strictly after the four-week mark, including Tuesday orders.
    completion.setUTCDate(completion.getUTCDate() + ((9 - completion.getUTCDay()) % 7 || 7));
    const dateTime = [completion.getUTCFullYear(), String(completion.getUTCMonth() + 1).padStart(2, '0'), String(completion.getUTCDate()).padStart(2, '0')].join('-');
    const label = completion.toLocaleDateString(document.documentElement.lang || 'en', { timeZone: 'UTC', year: 'numeric', month: 'long', day: 'numeric' });
    const shortLabel = completion.toLocaleDateString(document.documentElement.lang || 'en', { timeZone: 'UTC', year: 'numeric', month: 'short', day: 'numeric' });
    const dates = [...root.querySelectorAll('[data-joa-completion-date]')];
    if (root.matches?.('[data-joa-completion-date]')) dates.push(root);
    dates.forEach(node => {
      if (node.dateTime !== dateTime) node.dateTime = dateTime;
      const displayLabel = node.dataset.joaDateFormat !== 'long' && node.closest('#MainContent .product-details') ? shortLabel : label;
      if (node.textContent !== displayLabel) node.textContent = displayLabel;
    });
    clearTimeout(timer);
    timer = setTimeout(() => update(), 60000);
  }
  function create(label) {
    const note = document.createElement('p');
    note.className = 'joa-completion-estimate joa-completion-estimate--shared';
    const date = document.createElement('time');
    date.dataset.joaCompletionDate = '';
    note.append(document.createTextNode(label + ' '), date);
    update(note);
    return note;
  }
  window.JoaCompletionDate = { update, create };
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node instanceof Element && (node.matches('[data-joa-completion-date]') || node.querySelector('[data-joa-completion-date]'))) update(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pageshow', () => update());
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
  update();
})();


